/* Abrazo Suave home section. Needs as-gsap.min.js, as-scrolltrigger.min.js, as-lenis.min.js (loaded before, deferred). */
(function () {
  const me = document.currentScript;
  const ADD = me?.dataset.add || 'Add to cart';
  const ADDED = me?.dataset.added || 'Added';
  const root = document.querySelector('.ash');
  if (!root) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasGsap = !!(window.gsap && window.ScrollTrigger);

  /* header offset: only when the theme header stays on screen */
  const header = document.querySelector('#header-component');
  const headerOffset = () => {
    if (!header) return 0;
    const box = header.closest('.header-section') || header;
    const pos = getComputedStyle(box).position;
    return pos === 'sticky' || pos === 'fixed' ? header.offsetHeight : 0;
  };
  root.style.setProperty('--ash-hdr', headerOffset() + 'px');

  /* manifesto words */
  const mp = root.querySelector('[data-ash-words]');
  let words = [];
  if (mp) {
    const berry = (mp.dataset.berry || '').toLowerCase().split(/\s+/).filter(Boolean);
    mp.innerHTML = mp.textContent.trim().split(/\s+/).map(w => {
      const span = document.createElement('span');
      span.className = 'ash-w' + (berry.includes(w.toLowerCase()) ? ' ash-berry' : '');
      span.textContent = w;
      return span.outerHTML;
    }).join(' ');
    words = [...mp.querySelectorAll('.ash-w')];
  }

  /* add to cart: real cart, dot flies to the theme cart icon, bubble updates */
  const cartIcon = () => document.querySelector('cart-icon') || document.querySelector('a[href$="/cart"]');
  root.querySelectorAll('[data-ash-add]').forEach(btn => btn.addEventListener('click', async () => {
    if (btn.disabled) return;
    btn.disabled = true;
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.ashAdd), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      const icon = cartIcon();
      const done = () => {
        if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
        btn.classList.add('is-done'); btn.textContent = ADDED;
        setTimeout(() => { btn.classList.remove('is-done'); btn.textContent = ADD; btn.disabled = false; }, 1800);
      };
      if (reduce || !hasGsap || !icon) return done();
      const from = btn.getBoundingClientRect(), to = icon.getBoundingClientRect();
      const dot = document.createElement('span'); dot.className = 'ash-fly'; document.body.appendChild(dot);
      gsap.set(dot, { left: from.left + from.width / 2 - 7, top: from.top + from.height / 2 - 7 });
      gsap.timeline({ onComplete: () => { dot.remove(); done(); } })
        .to(dot, { left: to.left + to.width / 2 - 7, duration: 0.6, ease: 'power1.inOut' }, 0)
        .to(dot, { top: to.top + to.height / 2 - 7, duration: 0.6, ease: 'back.in(1.2)' }, 0)
        .to(dot, { scale: 0.4, duration: 0.6, ease: 'power2.in' }, 0);
    } catch (e) {
      btn.disabled = false;
      window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
    }
  }));

  if (!hasGsap || reduce) return;
  gsap.registerPlugin(ScrollTrigger);
  /* mobile browser bars showing/hiding resize the viewport; don't recalculate (and jump) for that */
  ScrollTrigger.config({ ignoreMobileResize: true });

  /* smooth scroll on the home page only, wired into GSAP's clock */
  if (window.Lenis && !window.__ashLenis) {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__ashLenis = lenis;
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(t => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
  }

  const hero = root.querySelector('[data-ash-hero]');
  const title = root.querySelector('[data-ash-title]');
  const copy = root.querySelector('[data-ash-copy]');
  const o1 = root.querySelector('[data-ash-obj="1"]');
  const o2 = root.querySelector('[data-ash-obj="2"]');
  const wide = () => innerWidth >= 750;

  if (o1) gsap.set(o1, { rotate: -4 });
  if (o2) gsap.set(o2, { rotate: 3 });

  /* first entrance */
  gsap.timeline({ defaults: { ease: 'power3.out' } })
    .from(title, { y: 28, opacity: 0, duration: 0.7 })
    .from(copy.children, { y: 16, opacity: 0, duration: 0.5, stagger: 0.06 }, '-=0.35')
    .from(root.querySelectorAll('.ash-obj > *'), { opacity: 0, duration: 0.7, stagger: 0.04, ease: 'power2.out' }, '-=0.45');

  /* Horizon scrolls inside .page-wrapper on desktop (>=990px, html/body are overflow:hidden)
     and the window on mobile, so every trigger must follow whichever element really scrolls */
  const pageWrapper = document.querySelector('.page-wrapper');
  const scroller = () => pageWrapper && /auto|scroll/.test(getComputedStyle(pageWrapper).overflowY) ? pageWrapper : window;
  /* ScrollTrigger measures by jumping the scroll position; the theme's smooth scrolling breaks that */
  document.documentElement.style.scrollBehavior = 'auto';
  if (pageWrapper) pageWrapper.style.scrollBehavior = 'auto';
  const mm = gsap.matchMedia();
  mm.add({ desk: '(min-width: 990px)', mob: '(max-width: 989px)' }, () => {
    const sc = scroller();
    ScrollTrigger.defaults({ scroller: sc });
    /* a fixed pin would sit outside .page-wrapper and swallow the wheel, so pin by transform there */
    const pinType = sc === window ? 'fixed' : 'transform';

    /* pinned hero: title recedes, photos land on the product cards */
    const endScale = obj => wide() ? 340 / obj.offsetWidth : 1.3;
    const delta = (obj, i, axis) => () => {
      const o = { x: obj.offsetLeft + obj.offsetWidth / 2, y: obj.offsetTop + obj.offsetHeight / 2 };
      const vw = hero.offsetWidth, vh = hero.offsetHeight;
      const tx = vw / 2 + (i === 0 ? -1 : 1) * (wide() ? 190 : 84);
      const ty = wide() ? vh - (obj.offsetWidth * endScale(obj)) / 2 - 24 : vh * 0.56;
      return axis === 'x' ? tx - o.x : ty - o.y;
    };
    const handoff = () => root.classList.toggle('ash-handoff', wide() && !!o1 && !!o2);
    handoff();
    const tl = gsap.timeline({ scrollTrigger: {
      trigger: hero, start: () => 'top ' + headerOffset(), end: () => '+=' + (innerHeight * (wide() ? 1.0 : 0.7)),
      pin: true, pinType, anticipatePin: 1, scrub: 0.6, invalidateOnRefresh: true, onRefreshInit: handoff
    } });
    tl.to(root.querySelector('[data-ash-field]'), { yPercent: -6, scale: 1.08, ease: 'none', duration: 1 }, 0)
      .to(root.querySelector('[data-ash-hint]'), { opacity: 0, duration: 0.1 }, 0)
      .to(copy, { opacity: 0, y: -30, ease: 'power1.in', duration: 0.35 }, 0)
      .to(title, { scale: 0.62, yPercent: -110, opacity: 0, ease: 'power1.inOut', duration: 0.7 }, 0)
      .to(root.querySelectorAll('.ash-objtag'), { opacity: 0, duration: 0.2 }, 0.05)
      .to(root.querySelector('[data-ash-next]'), { opacity: 1, y: 0, duration: 0.25 }, 0.75);
    if (o1) tl.to(o1, { x: delta(o1, 0, 'x'), y: delta(o1, 0, 'y'), rotate: 0, scale: () => endScale(o1), ease: 'power2.inOut', duration: 0.9 }, 0.05);
    if (o2) tl.to(o2, { x: delta(o2, 1, 'x'), y: delta(o2, 1, 'y'), rotate: 0, scale: () => endScale(o2), ease: 'power2.inOut', duration: 0.9 }, 0.1);
    gsap.set(root.querySelector('[data-ash-next]'), { y: 20 });

    /* sections enter by content, once */
    const once = (el, vars, trigger) => gsap.from(el, { scrollTrigger: { trigger: trigger || el, start: 'top 85%', once: true }, ...vars });
    root.querySelectorAll('[data-ash-reveal="drop"]').forEach((el, i) => once(el, { y: -36, opacity: 0, duration: 0.7, delay: i * 0.07, ease: 'back.out(1.6)' }));
    root.querySelectorAll('[data-ash-reveal="rise"]').forEach(el => once(el, { y: 26, opacity: 0, duration: 0.6, ease: 'power3.out' }));
    root.querySelectorAll('[data-ash-reveal="cloth"]').forEach(el => once(el, { y: 40, rotate: -3, opacity: 0, duration: 0.85, ease: 'expo.out' }));
    root.querySelectorAll('[data-ash-reveal="stack"]').forEach(el => once(el.children, { y: 30, opacity: 0, duration: 0.55, stagger: 0.07, ease: 'back.out(1.3)' }, el));

    /* manifesto: words light up with scroll position (reversible) */
    const man = root.querySelector('[data-ash-manifesto]');
    if (man && words.length) ScrollTrigger.create({ trigger: man, start: 'top top', end: 'bottom bottom', onUpdate: s => {
      const n = Math.round(s.progress * (words.length + 1));
      words.forEach((w, i) => w.classList.toggle('is-lit', i < n));
    } });

    if (sc !== window) ScrollTrigger.refresh();
  });

  window.addEventListener('load', () => ScrollTrigger.refresh());
})();
